// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14ved","newExpiryDate":"styles_newExpiryDate__2u0Sa","footer":"styles_footer__1PRCy"};